import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import {
    Unstable_NumberInput as BaseNumberInput,
    numberInputClasses,
} from '@mui/base/Unstable_NumberInput';
import { useNavigate } from 'react-router-dom';
import { useAsyncDebounce } from "react-table";
import { allProductApprovalList, productWiseApprovalList,approveEachProduct,saveModifiedQty } from "../../api/approval";
import { toast } from 'react-toastify';
import { child_employees,requisition_create, products } from '../../api/requisition';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { useApprovalFilter } from "../../Components/Hooks/UseApprovalFilter";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
import useTitle from '../../helpers/helper';
 
const ApprovalRequisition = () => {

    const dispatch = useDispatch();
    useTitle("Procurement-approval-requisition");

    dispatch(StorePageHeaderName('Approval Requisition'));

    const navigate = useNavigate();
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedProductName, setSelectedProductName] = useState(null);
    const [allocationQty, setAllocationQty] = useState(null);
    const [allocationQtyMap, setAllocationQtyMap] = useState({});
    const [savedRows, setSavedRows] = useState([]);
    const [newRows, setNewRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addMoreBtn, setAddMoreBtn] = useState(false)
    const [gridLoad, setGridLoad] = useState(false)

    const [rows, setRows] = useState([
        {
            id: '',
            executiveName: '',
            quantity: '',
            employee_id: '',
            requisition_no: '',
            requisition_date: ''
            // value: ''
        }
    ])
    const [executiveName, setExecutiveName] = useState(null);
    const [quantity, setQuantity] = useState('');

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const openModal = (isOpen, params) => {
        setModalIsOpen(isOpen);
        setSelectedRowId(params.id)
        setSelectedProductName(params.row.Product_Name)
        inApprovalProducts(params.id)
        setEditedRows([])
    };

    const [rowErrors, setRowErrors] = useState({});
    const [clickOnEdit, setClickOnEdit] = useState(null);
    const [editedRows, setEditedRows] = useState([]);
    const [newRowData, setNewRowData] = useState({
        executiveName: '',
        quantity: '',
    });
    const [showNewRowFields, setShowNewRowFields] = useState(false);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [quantityError, setQuantityError] = useState('');
    const [executiveError, setExecutiveError] = useState('');
    const [quantityDisabled, setQuantityDisabled] = useState(true);


    const inApprovalProducts = async(item_no)=>{
        try {
            setLoading(true)
            const approvalProducts = await productWiseApprovalList(item_no)
            const results = approvalProducts.data.productWiseApproval
            if(approvalProducts.statusCode === 200 && results.length >0){
                const formattedRecords = results.map((result, index) => ({
                    executiveName: result.user.first_name+' '+result.user.last_name,
                    quantity: result.modified_qty,
                    id: result.id,
                    employee_id: result.user.id,
                    requisition_no: result.procurementRequisition.requisition_number,
                    requisition_date: result.procurementRequisition.requisition_date

                }))
                setRows(formattedRecords)
            }
        }
        catch(error){
            toast.error('Error in fetching approval users for sales head')
            console.log(error)
        }finally{
            setLoading(false)
        }
    }


    const closeModal = () => {
        setModalIsOpen(false);
        setClickOnEdit(false);
        setAllocationQtyMap({});
        setSavedRows([])
        setAllocationQtyMap({});
        setShowNewRowFields(false)
        setAddMoreBtn(false)
        setQuantityError('')



    };
    const top100Films = [
        { label: 'The Shawshank Redemption', year: 1994 },
        { label: 'The Godfather', year: 1972 },
        { label: 'The Godfather: Part II', year: 1974 },
        { label: 'The Dark Knight', year: 2008 },
        { label: '12 Angry Men', year: 1957 },
     ]

    const [showList, setShowList] = useState(false);

    const toggleList = () => {
        setShowList(!showList);
    };

    const [pendingProducts, setPendingProducts] = useState([])
    const handleAddRow = () => {
        setRows([...rows, { productName: '', quantity: '', value: '' }]);
    };
    const handleDeleteRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
    };
    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleRowClick = (params) => {
        openModal(true, params);
      };

    const columns = [
        {
            field: 'Sl_No',  headerName: 'Sl.No',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: .5,
            sortable: false,
            resizable: false,
        },
        // {
        //     field: 'Requisition_No',
        //     headerName: 'Requisition No',
        //     width: 160,
        //     editable: true,
        //     flex: 1,
        // },
        {
            field: 'Requisition_Date',
            headerName: 'Requisition Date',
            width: 160,
            editable: true,
            flex: 1,
        },
        // {
        //     field: 'Requisition_No',
        //     headerName: 'Requisition No',
        //     width: 160,
        //     editable: true,
        // },
        // {
        //     field: 'Requisition_Date',
        //     headerName: 'Requisition Date',
        //     width: 160,
        //     editable: true,
        // },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            width: 230,
            sortable: false,
            resizable: false,
            flex: 1,
            renderCell: (params) => {
                // const productName = params.value;
                // return (
                //     <div onClick={openModal}>
                //         {productName}
                //     </div>
                // );
            },
        },
        {
            field: 'Total_Qty',
            headerName: 'Total Quantity',
            sortable: false,
            resizable: false,
            width: 160,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'Value',
            headerName: 'Value',
            // description: 'This column has a value getter and is not sortable.',
            sortable: false,
            resizable: false,
            width: 160,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'Status',
            headerName: 'Status',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            width: 160,
            flex: 1,
            renderCell: (params) => {
                let status = params.value;
                // Define the color for the chip based on the status
                let chipColor = 'default';
                if (status === 'APPROVAL_PENDING') {
                    chipColor = 'error'; // Red color for waiting for response
                    status = 'Approval Pending'
                } else if (status == 'approved') {
                    chipColor = 'success'; // Green color for approved
                }

                // Render the Chip component with the outlined variant and appropriate color
                return <Chip className="status_badge mt-1 mb-1" label={status} variant="outlined" color={chipColor} />;
            },
        },
    ];

    const blue = {
        100: '#DAECFF',
        200: '#80BFFF',
        400: '#3399FF',
        500: '#007FFF',
        600: '#0072E5',
        700: '#0059B2',
    };

    const grey = {
        50: '#F3F6F9',
        100: '#E5EAF2',
        200: '#DAE2ED',
        300: '#C7D0DD',
        400: '#B0B8C4',
        500: '#9DA8B7',
        600: '#6B7A90',
        700: '#434D5B',
        800: '#303740',
        900: '#1C2025',
    };

    const StyledInputRoot = styled('div')(
        ({ theme }) => `
            font-family: 'IBM Plex Sans', sans-serif;
            font-weight: 400;
            border-radius: 4px;
            color: #0060AA;
            background: transparent;
            border: 1px solid #0060AA;
            box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
            };
            display: grid;
            grid-template-columns: 1fr 19px;
            grid-template-rows: 1fr 1fr;
            overflow: hidden;
            column-gap: 8px;
            padding: 3px 4px;

            &.${numberInputClasses.focused} {
              border-color: #0060AA;
            }

            &:hover {
              border-color: #0060AA;
            }

            // firefox
            &:focus-visible {
              outline: 0;
            }
          `,
    );

    const StyledInputElement = styled('input')(
        ({ theme }) => `
            font-size: 1rem;
            font-family: inherit;
            font-weight: 400;
            line-height: 1.5;
            grid-column: 1/2;
            grid-row: 1/3;
            color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
            background: inherit;
            border: none;
            border-radius: inherit;
            padding: 2px 12px;
            outline: 0;
          `,
    );

    const StyledButton = styled('button')(
        ({ theme }) => `
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            appearance: none;
            padding: 0;
            width: 0px;
            height: 19px;
            font-family: system-ui, sans-serif;
            font-size: 0.875rem;
            line-height: 1;
            box-sizing: border-box;
            background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
            border: 0;
            color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 120ms;

            &:hover {
              background: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
              border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
              cursor: pointer;
            }

            &.${numberInputClasses.incrementButton} {
              grid-column: 2/3;
              grid-row: 1/2;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              border: 1px solid;
              border-bottom: 0;
              border-color: transparent;
              background: transparent;
              color: #0060AA;

              &:hover {
                cursor: pointer;
                color: #0060AA;
                background: transparent;
                border-color:transparent;
              }
            }

            &.${numberInputClasses.decrementButton} {
              grid-column: 2/3;
              grid-row: 2/3;
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
              border: 1px solid;
              border-color:transparent;
              background: transparent;
              color: #0060AA;
            }

            &:hover {
              cursor: pointer;
              color: #0060AA;
              background: transparent;
              border-color: transparent;
            }

            & .arrow {
              transform: translateY(-1px);
            }

            & .arrow {
              transform: translateY(-1px);
            }
          `,
    );
    const CustomNumberInput = React.forwardRef(function CustomNumberInput(props, ref) {
        return (
            <BaseNumberInput
                slots={{
                    root: StyledInputRoot,
                    input: StyledInputElement,
                    incrementButton: StyledButton,
                    decrementButton: StyledButton,
                }}
                slotProps={{
                    incrementButton: {
                        children: '▴',
                    },
                    decrementButton: {
                        children: '▾',
                    },
                }}
                {...props}
                ref={ref}
            />
        );
    });
    const fetchApprovalRequisition = async(payload = {})=>{
        try {
            setGridLoad(true)
            const productApprovalList = await allProductApprovalList(payload)

            const result = productApprovalList.data.allProductsApproval
            if(productApprovalList.statusCode === 200 && result.length >0){
                const formattedProducts = result.map((product, index) => ({
                    id: product.item_no, // Assuming index + 1 as ID
                    Sl_No: index + 1, // Serial Number
                    Product_Name: product.item_name,
                    Total_Qty: product.sum_total_qty,
                    Value: product.sum_value,
                    Status: product.status
                }));
                setPendingProducts(formattedProducts)
            } else {
                setPendingProducts([])
            }
        }
        catch(error){
            toast.error('Error in fetching approval list for sales head')
            console.log(error)
        }
        finally{
            setGridLoad(false)
        }
    }
    const {
      productList,
      reqNoList,
      executiveList,
      filterPayload,
      setFilterPayload,
      handleSearch,
      handleReset
    } = useApprovalFilter({
        showList,
        status: 'APPROVAL_PENDING',
        requisition_role: 'SALES_HEAD',
        callback: fetchApprovalRequisition
    });

    useEffect(()=>{
        fetchApprovalRequisition()
    },[])

    const handleEditClick = (index) => {
        if (editedRows.includes(index)) {
            setEditedRows(editedRows.filter((i) => i !== index));
        } else {
            setEditedRows([...editedRows, index]);
        }
        setAllocationQtyMap({ ...allocationQtyMap, [index]: ''});

    };

    const handleAllocationQtyChange = (index, value) => {
        if (parseInt(value) > 9999) {
            setRowErrors({ ...rowErrors, [index]: 'Quantity should be less than 9999' });
        } else {
            setRowErrors({ ...rowErrors, [index]: '' });
        }
        setAllocationQtyMap({ ...allocationQtyMap, [index]: value });
    };

    // const handleModifiedClick = async (index) => {
    //     const updatedRows = [...rows];
    //     const newAllocationQtyMap = { ...allocationQtyMap };
    //     if (newAllocationQtyMap[index] === '') {
    //         setRowErrors((prevErrors) => ({
    //             ...prevErrors,
    //             [index]: 'Quantity is required ',
    //         }));
    //         return;
    //     }
    //     else if (newAllocationQtyMap[index].toString().length > 4) {
    //         return;
    //     }
    //     updatedRows[index].quantity = newAllocationQtyMap[index];
    //     setRows(updatedRows);
    //     setEditedRows(editedRows.filter((i) => i !== index));
    //     setRowErrors({}); // Clear all previous errors
    // };


    // const handleSaveClick = (row) => {
    //     // Check if the row already exists in savedRows
    //     const existingIndex = savedRows.findIndex((savedRow) => savedRow.id === row.id);

    //     if (existingIndex !== -1) {
    //         const updatedRows = [...savedRows];
    //         updatedRows.splice(existingIndex, 1);
    //         setSavedRows([...updatedRows, row]);
    //     } else {
    //         setSavedRows([...savedRows, row]);
    //     }
    // };

    const handleDoneOperation = async()=>{
        try {
            updateModifedQty(savedRows)

            const itemsToUpdate = savedRows.map((saveRow, index) => ({
                requisition_item_id: saveRow.id,
               // modified_qty: Number(saveRow.quantity)
            }));
            const updateAllocationQty = await approveEachProduct (itemsToUpdate)
            if(updateAllocationQty.statusCode=== 200){
                closeModal()
                fetchApprovalRequisition()
                toast.success('Approval requisition saved successfully!!..')
            }

        }
        catch(error){
            toast.error('Error in saving executive approval for sales head')
            console.log(error)

        }
    }

    // const handleSaveAllClick = () => {
    //     // Update savedRows with all rows
    //     setSavedRows([...savedRows, ...rows]);


    // };
    const handleModifiedClick = async (index) => {
        const updatedRows = [...rows];
        const newAllocationQtyMap = { ...allocationQtyMap };
        if (newAllocationQtyMap[index] === '') {
            setRowErrors((prevErrors) => ({
                ...prevErrors,
                [index]: 'Quantity is required ',
            }));
            return;
        } else if (newAllocationQtyMap[index].toString().length > 4) {
            return;
        }
        updatedRows[index].quantity = newAllocationQtyMap[index];
        setRows(updatedRows);
        setEditedRows(editedRows.filter((i) => i !== index));
        setRowErrors({}); // Clear all previous errors

        // Save the modified row
        handleSaveClick(updatedRows[index]);

    };

    const handleSaveClick = (row) => {
        // Check if the row already exists in savedRows
        const existingIndex = savedRows.findIndex((savedRow) => savedRow.id === row.id);

        if (existingIndex !== -1) {
            const updatedRows = [...savedRows];
            updatedRows.splice(existingIndex, 1, row); // Update the existing row with modifications
            setSavedRows(updatedRows);
        } else {
            setSavedRows([...savedRows, row]);
        }
       // updateModifedQty([row])
    };

    const handleSaveAllClick = () => {
        // Update savedRows with all rows which are not already saved
        const newSavedRows = rows.filter((row) => !savedRows.some((savedRow) => savedRow.id === row.id));
        setSavedRows([...savedRows, ...newSavedRows]);
        // updateModifedQty(newSavedRows)
    };


    const fetchExecutiveOptions = async () => {
        try {
                  const response = await child_employees();
                  if (response.statusCode === 200 && response.data.allChilds.length > 0) {
                    const transformedData = response.data.allChilds.map(child => {
                      const { id, first_name, last_name } = child.userDetail;
                      return { label: `${first_name} ${last_name}`, value: id };
                    });
                    const filteredOptions = transformedData.filter(option => !rows.find(row => Number(row.employee_id) === option.value));
                    setExecutiveOptions(filteredOptions);

                  }

        } catch (error) {
            console.error('Error fetching executive options:', error);
        }
    };
    const handleAddNewRow = () => {
        try {

            if (!executiveName) {
                setExecutiveError('Executive name is required');
                return;
            }
            if (!quantity || quantity === '0') {
                setQuantityError('Quantity is required'); // Set error message if quantity is blank
                return;
            }
            createRequisition(selectedRowId)

            // setRows([...rows, newRowData]);
             setNewRowData({ executiveName: '', quantity: '' });
             setExecutiveName('');
             setQuantity('');
             setQuantityError('');
            setExecutiveError('');
             setShowNewRowFields(false);
             setAddMoreBtn(false)
             setLoading(true)
             setQuantityDisabled(true);

             toast.success('Requisition created successfully!!..')
        }
        catch (error){
            console.log('sales head modal approval creation failed', error)
            toast.error('sales head modal approval creation failed')
        }

    }
    const createRequisition = async(item_no) =>{
        try {
            const productDetails = await products({search_item_no:item_no})
            const result = productDetails.data.productList[0][0]
            if(productDetails.statusCode === 200){

                let items = [
                    {
                        total_qty: Number(quantity),
                        value:result.Dp * Number(quantity),
                        item_name: result.ItemName,
                        item_no:result.ItemNo,
                        p_type: result.Ptype,
                        vertical:result.Vertical,
                        itemseg: result.Itemseg,
                        category: result.Category,
                        dp: result.Dp,
                        mop: result.Mop,
                        vcode: result.Vcode,
                        vname: result.Vname,
                        vtype: result.Vtype

                    }
                ]
                let requisition_data = [
                    {req_total:result.Dp * Number(quantity),req_item_count: 1, user_id:executiveName.value,  items}
                ]
                try {
                    const createReq = await requisition_create({requisition_data} )
                    if(createReq.statusCode === 201 && createReq.data.requisitionItemDetails.length > 0){
                        inApprovalProducts(item_no)
                    }


                }
                catch(error){
                    console.error('Error creating requisition from menu:', error);
                    toast.error('Error creating requisition from menu')

                }

            }


        }catch (error) {
            console.error('Error fetching product details options:', error);
        }
    }
    const handleNewRowInputChange = (event) => {
        const { name, value } = event.target;
        setNewRowData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Function to toggle visibility of input fields
    const toggleNewRowFields = () => {
        setShowNewRowFields(!showNewRowFields);
        if (!showNewRowFields) {
            fetchExecutiveOptions();
            setAddMoreBtn(true)
        }

    };

  const handleExecutiveChange = (event, newValue) => {

    setExecutiveName(newValue);
    setExecutiveError('');
    setQuantityDisabled(false);


  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
    setQuantityError('');
  };

  const updateModifedQty = async(getRows)=>{
    try {
        console.log('getRows', getRows)
        const modifiedItems = getRows.map(row => ({
            requisition_item_id: row.id,
            modified_qty: Number(row.quantity)
        }))

        const modifiedReqItems = await saveModifiedQty(modifiedItems)
        if(modifiedReqItems.statusCode !== 200){
            toast.error('Saved item not modified in sales head')
        }

    }
    catch(error){
        console.log('Error in saving Quantity sales head', error)
        toast.error('Error in saving Quantity sales head')
    }
  }
    return (
        <React.Fragment>
            <Container fluid>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop:"10px" }}>
                        <div style={{ fontSize: '20px', }}>
                            <h4 className="mb-0 requisition_text">Approval Requisition</h4>
                        </div>
                        <div className="d-flex align-items-center">
                        <div>
                            <button onClick={toggleList} variant="outlined" className="filter_button"><span className="me-2"><TuneIcon /></span>Filter</button>
                        </div>
                        </div>
                    </div>
                    {showList && (

                        <div className="mt-2" style={{ display: 'flex', gap: '10px', alignItems: 'center',flexWrap:'wrap' }}>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={productList}
                                    onChange={(_, value) => setFilterPayload({...filterPayload, product:value})}
                                    value={filterPayload.product}
                                    sx={{ width: 200 }}
                                    renderInput={(params) => <TextField {...params} label="Search Product Name" />}
                                />
                            </div>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={reqNoList}
                                    field="reqNo"
                                    onChange={(_, value) => setFilterPayload({...filterPayload, reqNo:value})}
                                    value={filterPayload.reqNo}
                                    sx={{
                                        width: 200
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Requisition Number" />}
                                />
                            </div>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={executiveList}
                                    onChange={(_, value) => setFilterPayload({...filterPayload, executive:value})}
                                    value={filterPayload.executive}
                                    sx={{
                                        width: 190
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Executive" />}
                                />
                            </div>
                            <div>
                                <LocalizationProvider className='date_picker' dateAdapter={AdapterDayjs}>
                                    <DatePicker style={{ width: '140px' }}
                                        className='date_picker'
                                        label="From Date"
                                        value={filterPayload.startDate}
                                        maxDate={filterPayload.endDate}
                                        onChange={(value) => setFilterPayload({...filterPayload, startDate:value})}
                                         />
                                </LocalizationProvider>
                            </div>
                            <div>
                                <LocalizationProvider className='date_picker' dateAdapter={AdapterDayjs}>
                                    <DatePicker style={{ width: '140px' }}
                                        className='date_picker'
                                        label="To Date"
                                        value={filterPayload.endDate}
                                        minDate={filterPayload.startDate}
                                        onChange={(value) => setFilterPayload({...filterPayload, endDate:value})}
                                        />
                                </LocalizationProvider>
                            </div>
                            {/* <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={top100Films}
                                    sx={{ width: 160 }}
                                    renderInput={(params) => <TextField {...params} label="Status" />}

                                />
                            </div> */}
                            <div className="d-flex align-items-center">
                                <Button className="me-2 search_button" onClick={handleSearch}>Search</Button>
                                <ReplayIcon onClick={handleReset}/>
                            </div>

                        </div>
                    )}

                    <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop:'10px' }}>
                        <DataGrid
                            autoHeight
                            className="table_header_background"
                            headerClassName="custom-header-cell"
                            getRowHeight={() => 'auto'}
                            rows={pendingProducts}
                            columns={columns}
                            loading={gridLoad}
                            // initialState={{
                            //     pagination: {
                            //         paginationModel: {
                            //             pageSize: 5,
                            //         },
                            //     },
                            // }}
                            pageSizeOptions={[]}
                            disableRowSelectionOnClick
                            pageSize={pendingProducts.length}
                            onRowClick={handleRowClick}
                            disableColumnMenu
                            componentsProps={{
                              cell: {
                                disableClick: true,
                              },
                            }}
                            sx={{
                              '& .MuiDataGrid-cell': {
                                '& .MuiDataGrid-cell--textOverflow': {
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                },
                              },
                            }}

                        />
                    </Box>
                </div>
            </Container>
            <Modal
               className="createapproval_requisiton_modal modal_box "
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h3 className='ms-3'>{selectedProductName}</h3>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                <ModalBody className='pt-2'>
                    {/* <hr></hr> */}

                    {loading && (

                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1000
                        }}>
                            <CircularProgress />
                        </div>

                    )}
                     {!loading && (
                    <>
                        {rows.map((row, index) => (
                            <>
                            <div key={index} style={{ display: 'flex', gap: '12px', marginBottom: '16px', }}>
                                <div>
                                <h6 className="requisition_type_text">Requisition Number</h6>
                                    <p className="mb-0">{row.requisition_no}</p>
                                    {/* <TextField
                                        className="addrequisiton_field"
                                        id={`reqNo-${index}`}
                                        // label="Requisition Number"
                                        // variant="outlined"
                                        variant="standard"
                                        value={row.requisition_no}
                                        onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                                        sx={{ width: 160 }}
                                        disabled={true}

                                    /> */}
                                </div>
                                <div>
                                    <h6 className="requisition_type_text">Requisition Date</h6>
                                    <p className="mb-0">{row.requisition_date}</p>
                                    {/* <TextField
                                        className="addrequisiton_field"
                                        id={`reqDate-${index}`}
                                        // label="Requisition Date"
                                        // variant="outlined"
                                        variant="standard"
                                        value={row.requisition_date}
                                        onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                                        sx={{ width: 160 }}
                                        disabled={true}
                                    /> */}
                                </div>
                                <div>
                                <h6 className="requisition_type_text">Executive Name</h6>
                                    <p className="mb-0">{row.executiveName}</p>
                                {/* <h6 className="requisition_type_text" style={{ color:'#999999'}}>Executive Name</h6>
                                    <p className="mb-0" style={{ color:'#999999'}}>Subhasmita Mohapatra</p> */}
                                    {/* <TextField
                                    className="addrequisiton_field"
                                        id={`value-${index}`}
                                        // label="Executive Name"
                                        // variant="outlined"
                                        variant="standard"
                                        value={row.executiveName}
                                        onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                                        sx={{ width: 160 }}
                                        disabled={true}
                                    /> */}
                                </div>
                                <div>

                                    <CustomNumberInput sx={{ width: '125px' }} disabled={true}aria-label="Demo number input" placeholder="Quantity" value={row.quantity}/>
                                </div>

                                <div>
                                        {editedRows.includes(index)? (
                                            <>
                                                <TextField
                                                type="number"
                                                className="addrequisiton_field"
                                                id={`allocated-quantity-${index}`}
                                                label="Approved Quantity"
                                                variant="outlined"
                                                value={allocationQtyMap[index] || ''}
                                                onChange={(event) => handleAllocationQtyChange(index, event.target.value)}

                                                sx={{ width: '140px' }}
                                            />
                                            {editedRows.includes(index)  && (
                                                <div style={{ color: 'red', marginTop: '4px' }}>
                                                    {rowErrors[index]}
                                                </div>
                                            )}

                                            </>
                                        ) : (
                                            <button className="approval_edit" onClick={() => handleEditClick(index)}>Edit</button>
                                        )}
                                </div>
                                <div>
                                    {/* {!editedRows.includes(index) && (
                                        <button className="approval_edit"  onClick={() => handleSaveClick(row)}  disabled={savedRows.some((savedRow) => savedRow.id === row.id)}>Save</button>
                                    )} */}
                                   {!editedRows.includes(index) && !savedRows.some((savedRow) => savedRow.id === row.id) && (
                                        <button
                                            className="approval_edit"
                                            onClick={() => handleSaveClick(row)}
                                        >
                                            Save
                                        </button>
                                    )}
                                </div>
                                <div>
                                {editedRows.includes(index) && (
                                    <button className="approval_edit" onClick={() => handleModifiedClick(index)}>Modified</button>
                                )}

                                </div>
                            </div>
                            <hr></hr>
                            </>
                        ))}
                        {showNewRowFields && (
                            <>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <div>
                                    <Autocomplete
                                        disablePortal
                                        className="create_requisition_field"
                                        options={executiveOptions} // Pass executiveOptions array as options
                                        sx={{ width: 180 }}
                                        id='new-executive'
                                        onChange={handleExecutiveChange}

                                        renderInput={(params) => <TextField {...params} label="Executive Name" />}
                                    />
                                    {executiveError && (
                                            <div style={{ color: 'red', marginTop: '4px' }}>
                                                {executiveError}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <TextField
                                                    type="number"
                                                    className="addrequisiton_field"
                                                    id={'new-quanyity'}
                                                    label="Quantity"
                                                    variant="outlined"
                                                    value={quantity}
                                                    onChange={handleQuantityChange}
                                                    sx={{ width: '150px' }}
                                                    disabled={quantityDisabled}
                                        />
                                         {quantityError && (
                                            <div style={{ color: 'red', marginTop: '4px' }}>
                                                {quantityError}
                                            </div>
                                        )}


                                    </div>
                                    <div>

                                        <Button className="approval_edit" onClick={handleAddNewRow} variant="outlined">Add</Button>
                                        {/* <HighlightOffIcon onClick={toggleNewRowFields} color='error' /> */}
                                    </div>
                                </div>
                                <hr></hr>
                            </>
                        )}
                    </>
                     )}
                    {!showNewRowFields && <Button variant="contained" className="add_more_button" onClick={toggleNewRowFields}disabled={addMoreBtn}>+ Add More</Button>}
                    <Button variant="contained" className="add_more_button ms-2" onClick={handleSaveAllClick}>Save All</Button>

                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                    <Button variant="contained" className="yes_button d-flex align-items-center" onClick={handleDoneOperation} disabled={savedRows.length === 0}>Done</Button>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default ApprovalRequisition;
